import React from "react";
import styled from "styled-components";
import { Link, graphql, StaticQuery } from "gatsby";

const NavItem = styled(Link)`
  text-decoration: none;
  color: white;
  white-space: nowrap;
  font-family: "Nexa";
  height: 100%;
  display: flex;
  place-items: center;
  padding: 0 45px;

  display: flex;
  position: relative;

  :hover {
    /* background: #9a1c1f;
    transition: all 0.4s ease-in;

    ::after {
      width: 100%;
    } */
  }
  &.active {
    /* color: #9a1c1f; */
    background: #9a1c1f;
  }

  @media (max-width: 768px) {
    margin: 20px 0;
    font-size: 1.5rem;
    z-index: 6;
    height: 20%;

    &.active {
      color: #9a1c1f;
      background: transparent;
    }
  }
`;
const NavItemUnClickable = styled.a`
  text-decoration: none;
  color: white;
  white-space: nowrap;
  font-family: "Nexa";
  display: flex;
  place-items: center;
  padding: 0 45px;

  display: flex;
  position: relative;

  :hover {
    /* background: #9a1c1f;
    transition: all 0.4s ease-in;

    ::after {
      width: 100%;
    } */
  }
  &.active {
    /* color: #9a1c1f; */
    background: #9a1c1f;
  }

  @media (max-width: 768px) {
    padding: 20px 0;
    font-size: 1.5rem;
    z-index: 6;
    &.active {
      color: #9a1c1f;
      background: transparent;
    }
  }
`;
const NavMenu = styled.ul`
  display: none;
  flex-direction: column;
  list-style: none;
  position: absolute;
  top: 126px;
  background: #9a1c1f;
  color: white;
  width: 100%;
  font-size: 0.8rem;
  margin: 0;
  text-transform: capitalize;
  a {
    font-family: "Nexa";
    color: white;
    text-decoration: none;
  }
  li {
    padding-left: 10px;
    :hover {
      background: #27213c;
    }
  }
  @media (max-width: 968px) {
    position: unset;
    background: transparent;
    a {
      font-family: "Nexa Bold";
      :hover {
        color: #efca69;
      }
    }
    li {
      margin: auto;
      padding: 5px 0px;
    }
  }
`;
const NavItemWrapper = styled.div`
  position: relative;
  height: 100%;
  justify-content: center;
  @media (max-width: 968px) {
  }
  display: flex;
  flex-direction: column;
  :hover {
    background: #9a1c1f;
    @media (max-width: 968px) {
      background: transparent;
    }
    ${NavItem} , ${NavItemUnClickable} {
      ::after {
        width: 100%;
      }
      @media (max-width: 968px) {
        color: #9a1c1f;
      }
    }

    ${NavMenu} {
      transition: all 0.9s ease-in;
      @media (max-width: 968px) {
      }
      display: block;
    }
  }
`;
const NavbarLinks = () => {
  return (
    <>
      <NavItemWrapper>
        <NavItem activeClassName="active" to="/about">
          About Us
        </NavItem>
      </NavItemWrapper>
      <NavItemWrapper>
        <NavItemUnClickable activeClassName="active">
          Services
        </NavItemUnClickable>
        <NavMenu>
          <StaticQuery
            query={graphql`
              query Nav {
                allMarkdownRemark(
                  sort: { order: DESC, fields: [frontmatter___date] }
                  filter: {
                    frontmatter: { templateKey: { eq: "service-post" } }
                  }
                ) {
                  edges {
                    node {
                      excerpt(pruneLength: 400)
                      id
                      fields {
                        slug
                      }
                      frontmatter {
                        title
                        templateKey
                        date(formatString: "MMMM DD, YYYY")
                      }
                    }
                  }
                }
              }
            `}
            render={(data, count) => {
              return (
                <>
                  {data.allMarkdownRemark.edges.map((edge, index) => (
                    <li key={index}>
                      <Link to={edge.node?.fields.slug}>
                        {edge.node?.frontmatter.title}
                      </Link>
                    </li>
                  ))}
                </>
              );
            }}
          />
        </NavMenu>
      </NavItemWrapper>
      <NavItemWrapper>
        <NavItem activeClassName="active" to="/partners">
          Partners
        </NavItem>
      </NavItemWrapper>
      <NavItemWrapper>
        <NavItem activeClassName="active" to="/contact">
          Contact Us
        </NavItem>
      </NavItemWrapper>
    </>
  );
};

export default NavbarLinks;
